// extracted by mini-css-extract-plugin
module.exports = {"details":"disclosure_details__5sjvD","summary":"disclosure_summary__QWeXl","summaryContent":"disclosure_summaryContent__Npoq5","chevron":"disclosure_chevron__IjJWp"};